// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 查询目录列表(app) GET /app/course/catalog/list */
export async function appCourseCatalogListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.appCourseCatalogListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListCourseCatalogResp>('/app/course/catalog/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
